import React from 'react';
import { View, StyleSheet, ImageBackground } from 'react-native';
import { Colors } from 'react-native-paper';
import { pixelDimensions, getOrientarion } from '../../config/utils';

import { AppButton, AppText } from '../form';

const CardButton = ({
  onPress, image, label, style,
}) => (
  <View style={[styles.card, style]}>
    <AppButton primary disableDefaultColor rippleColor={Colors.indigo700} style={styles.buttonCard} onPress={onPress}>
      <View style={styles.textContainer}>
        <ImageBackground source={image} style={styles.imageButton} />
        <View style={styles.viewTextButton}>
          <AppText style={styles.textButtonText}>{label}</AppText>
        </View>
      </View>
    </AppButton>
  </View>
);

const styles = StyleSheet.create({
  buttonCard: {
    flex: 1,
  },
  card: {
    backgroundColor: Colors.white,
    marginVertical: pixelDimensions(2),
    marginHorizontal: pixelDimensions(4),
  },
  imageButton: {
    flex: getOrientarion() === 'PORTRAIT' ? 3 : 1,
    opacity: 0.6,
  },
  textButtonText: {
    fontSize: pixelDimensions(5),
    color: Colors.grey700,
  },
  textContainer: {
    flex: 1,
    flexDirection: getOrientarion() === 'PORTRAIT' ? 'column' : 'row',
  },
  viewTextButton: {
    flex: 1,
    paddingVertical: pixelDimensions(1),
    paddingHorizontal: pixelDimensions(4),
    justifyContent: 'center',
  },
});

export default CardButton;
